//= require personalised-config.js
//= require personalised-utils.js
//= require personalised-validation.js
// CUSTOM: personalised-bundle-utils.js

(function() {
  window.personalised = window.personalised || {};
  
  // Utility functions for bundle operations
  const bundleUtils = {
    // Moved directly from personalised-bundle-builder.js and simplified
    buildPayload: function(bundleProductId, bundleVariantId) {
      // Define a valid default payload structure
      const defaultPayload = {
        externalProductId: bundleProductId || null,
        externalVariantId: bundleVariantId || null,
        selections: []
      };
      
      // Validate inputs and state availability
      if (!bundleProductId || !bundleVariantId) {
        console.warn('Bundle buildPayload: Missing product or variant ID');
        return defaultPayload;
      }
      
      // Validate bundle state is loaded and has items
      if (!window.personalised.validation.validateBundleLoaded()) {
        console.warn('Bundle buildPayload: Bundle not loaded or empty');
        return defaultPayload;
      }
      
      // Get items once to ensure consistency
      const bundleItems = window.personalised.bundle.getItems();
      
      // Proceed with normal behavior when all validations pass
      return {
        externalProductId: bundleProductId,
        externalVariantId: bundleVariantId,
        selections: bundleItems.map(item => ({
          collectionId: item.collectionId || null,
          externalProductId: item.productId || null,
          externalVariantId: item.variantId || null,
          quantity: (item.quantity || 1) * window.personalised.bundle.getFrequencyMultiplier(),
          sellingPlan: item.sellingPlanId || null
        }))
      };
    },    
    
    getBundlePayload: function () {
      try {
        const bundleProductId = window.personalised.config && window.personalised.config.bundleProductId;
        const bundleVariantId = window.personalised.config && window.personalised.config.bundleVariantId;
        
        // Directly call the buildPayload function
        return this.buildPayload(bundleProductId, bundleVariantId);
      } catch (error) {
        console.error('Error building bundle payload:', error);
        // Return a safe minimal payload to prevent breaking downstream code
        return { selections: [] };
      }
    },
      // Private implementation shared by both refresh methods    
    _executeCartRefresh: async function(message = null, useDebounced = false) {
      try {
        // Mode validation is now handled by storageManager
        
        if (window.personalised?.config?.debugMode) {
          console.debug('[_executeCartRefresh] Cart sync check state:', {
            loadedFromRecharge: !!window.personalised?._loadedFromRecharge,
            initializationInProgress: !!window.personalised?._initializationInProgress,
            currentMode: window.personalised.utils.getMode(),
            editMode: window.personalised?.config?.modes?.EDIT || 'edit',
            isEditMode: window.personalised.utils.getMode() === (window.personalised?.config?.modes?.EDIT || 'edit')
          });
        }
        
        // Cart sync safeguards now handled through other mechanisms
        
        // Cart sync safeguard: prevent rebuild if bundle came from Recharge
        if (window.personalised?._loadedFromRecharge) {
          console.info('Skipping cart sync: bundle loaded from Recharge');
          return [];
        }
        
        // Cart sync safeguard: prevent rebuild if initialization is in progress
        if (window.personalised?._initializationInProgress) {
          console.info('Skipping cart sync: initialization in progress');
          return [];
        }

        // Skip cart sync entirely in edit mode
        if (window.personalised.utils.getMode() === window.personalised.config.modes.EDIT) {
          console.info('Skipping cart sync: edit mode active');
          return [];
        }
        
        // Validate that bundle state is loaded
        if (!window.personalised.validation.validateBundleLoaded()) {
          console.error('Bundle state not loaded');
          if (window.personalised.eventBus) {
            window.personalised.eventBus.emit('syncFailed', { 
              error: new Error('Bundle state not loaded'),
              message: 'Unable to update cart: bundle state not available'
            });
          }
          return [];
        }
        
        // Check if there are items in the bundle
        if (!window.personalised.validation.bundleHasItems()) {
          // Handle empty state - just remove all bundle items from cart
          if (window.personalised.cartSync) {
            try {
              await window.personalised.cartSync.rebuildInCart([]);
            } catch (syncError) {
              console.error('Error syncing empty state to cart:', syncError);
              if (window.personalised.eventBus) {
                window.personalised.eventBus.emit('syncFailed', { 
                  error: syncError,
                  message: 'Failed to clear cart items'
                });
              }
            }
          }
          return [];
        }
          // Get bundle payload with error handling already built in
        const payload = window.personalised.utils.getBundlePayload();
        
        // Use the BUNDLE_PARENT_PROPERTY_KEY from config
        const bundleParentKey = window.personalised.config && 
          window.personalised.config.bundle?.BUNDLE_PARENT_PROPERTY_KEY || 'shopifyProductHandle';
          // Get dynamic bundle items with error handling
        let lineItems = [];
        
        try {
          // Wait for the SDK to be initialized
          await window.personalised.utils.waitForRechargeSDK();

          // Ensure the method is available before calling
          if (!window.recharge?.bundle?.getDynamicBundleItems) {
            throw new Error('Recharge bundle SDK method not available');
          }
          
          lineItems = await window.recharge.bundle.getDynamicBundleItems(payload, bundleParentKey);
          
          // Validate returned lineItems
          if (!Array.isArray(lineItems)) {
            throw new Error('Invalid line items response from Recharge SDK');
          }
        } catch (rechargeError) {
          console.error('Error with Recharge SDK:', rechargeError);
          
          // Optional: emit syncFailed to gracefully inform the UI or calling logic
          if (window.personalised.eventBus) {
            window.personalised.eventBus.emit('syncFailed', { 
              error: rechargeError,
              message: 'Failed to prepare your bundle items'
            });
          }
          
          // Fallback: Return empty result to avoid runtime failure
          return [];
        }
        
        // Choose between immediate or debounced cart sync
        try {
          if (!window.personalised.cartSync) {
            throw new Error('Cart sync module not found');
          }
          
          if (useDebounced && typeof window.personalised.cartSync.debouncedRebuildInCart === 'function') {
            await window.personalised.cartSync.debouncedRebuildInCart(lineItems, message);
          } else if (typeof window.personalised.cartSync.rebuildInCart === 'function') {
            // Use immediate sync as default or fallback
            await window.personalised.cartSync.rebuildInCart(lineItems);
          } else {
            throw new Error('No valid cart sync method available');
          }
        } catch (syncError) {
          console.error('Error syncing bundle to cart:', syncError);
          if (window.personalised.eventBus) {
            window.personalised.eventBus.emit('syncFailed', { 
              error: syncError,
              message: 'Failed to update your cart'
            });
          }
          return lineItems; // Still return lineItems for use by caller
        }
        
        return lineItems;
      } catch (error) {
        // Catch any other unexpected errors
        console.error(`Unexpected error in cart refresh (${useDebounced ? 'debounced' : 'immediate'}):`, error);
        if (window.personalised.eventBus) {
          window.personalised.eventBus.emit('syncFailed', { 
            error: error,
            message: 'An unexpected error occurred'
          });
        }
        return [];
      }
    },    
    
    // Public methods that leverage the shared implementation
    refreshCartFromState: async function(message = null) {
      // Use shared implementation with immediate sync
      return this._executeCartRefresh(message, false);
    },
      // Debounced version to replace direct calls in event handlers
    debouncedRefreshCartFromState: async function(message = null) {
      // Use shared implementation with debounced sync
      return this._executeCartRefresh(message, true);
    }
  };
  
  // Price calculator implementation (merged from personalised-price-calculator.js)
  const priceCalculator = {
    // Calculate total price of all items in bundle
    calculateTotalPrice: function(items, variantLookup) {
      let totalCents = 0;
      if (items && variantLookup) {
        items.forEach(item => {
          const lookup = variantLookup[String(item.variantId)];
          if (lookup && lookup.variant && typeof lookup.variant.price_cents === 'number') {
            totalCents += lookup.variant.price_cents;
          }
        });
      }
      return totalCents;
    },  
    
    // Apply frequency multiplier to price
    applyFrequencyMultiplier: function(totalCents, frequency) {
      // Get the multiplier - use the standardized function from config
      const packCount = window.personalised.config.getFrequencyMultiplier(frequency);
      return totalCents * packCount;
    },
    
    // Apply discount based on frequency
    applyFrequencyDiscount: function(totalCentsWithMultiplier, frequency) {
      const freq = parseInt(frequency, 10) || 30;
      let discountedTotal = totalCentsWithMultiplier;
      
      // Get discount values from config
      const discounts = window.personalised.config.subscription.discounts;
      
      // Apply discount for 60 or 90 day frequency
      if (freq === 60) {
        discountedTotal = Math.round(totalCentsWithMultiplier * (1 - discounts[60])); // Using config discount value
      } else if (freq === 90) {
        discountedTotal = Math.round(totalCentsWithMultiplier * (1 - discounts[90])); // Using config discount value
      }
      
      return discountedTotal;
    },

    // Calculate per day price
    calculatePerDayPrice: function(totalCentsDiscounted, frequency) {
      const freq = parseInt(frequency, 10) || 30;
      let perDay = 0;
      
      if (totalCentsDiscounted > 0 && freq > 0) {
        perDay = (totalCentsDiscounted / 100) / freq;
      }
      
      return perDay;
    },

    // Format price to currency string
    formatPrice: function(cents, includeCurrency = true) {
      const amount = cents > 0 ? (cents / 100).toLocaleString(undefined, { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      }) : '0.00';
      
      return includeCurrency ? `$${amount}` : amount;
    },
    
    // Calculate the before discount price (original price)
    calculateBeforeDiscountPrice: function(totalCentsWithMultiplier, frequency) {
      const freq = parseInt(frequency, 10) || 30;
      
      // For 30-day frequency, return the same price (no discount)
      if (freq === 30) {
        return totalCentsWithMultiplier;
      }
      
      // For 60-day and 90-day, we need to return the non-discounted price
      // which is already correctly calculated as totalCentsWithMultiplier
      return totalCentsWithMultiplier;
    },  
    
    // Get pack count based on frequency - this is just an alias for getFrequencyMultiplier
    getPackCount: function(frequency) {
      return window.personalised.config.getFrequencyMultiplier(frequency);
    }
  };

  // Assign to single namespace
  window.personalised.utils = Object.assign(window.personalised.utils || {}, bundleUtils);
  window.personalised.priceCalculator = priceCalculator;
})();

// NOTE: All event handling for [data-add-to-pack] is now delegated in personalised-bundle-manager.js
// Use data-* attributes for any future selectors or event logic
